<template>
  <div class="acupointList">
    <el-card shadow="never">
      <div class="header-flex">
        <h1>小儿穴位列表</h1>
        <div class="input-flex">
          <div class="input-flex">
            <el-input
              placeholder="请输入搜索内容"
              v-model.lazy="keyword"
              prefix-icon="el-icon-search"
              clearable
              class="input"
            ></el-input>
          </div>
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        :max-height="scrollHeight"
      >
        <el-table-column
          fixed
          prop="id"
          label="ID"
          width="100"
        ></el-table-column>
        <el-table-column
          fixed
          prop="cat_name"
          label="经络名称"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="穴位名称"
          width="150"
        ></el-table-column>
        <el-table-column prop="definition_pinyin" label="部位">
          <template slot-scope="scope">
            <el-popover placement="top" width="600" trigger="hover">
              <div v-html="scope.row.definition_pinyin"></div>
              <div slot="reference">
                {{ scope.row.definition_pinyin | filterSplit }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="definition_cat_belongs_to" label="操作手法">
          <template slot-scope="scope">
            <el-popover placement="top" width="600" trigger="hover">
              <div v-html="scope.row.definition_cat_belongs_to"></div>
              <div slot="reference">
                {{ scope.row.definition_cat_belongs_to | filterSplit }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="definition_major_functions" label="具体操作">
          <template slot-scope="scope">
            <el-popover placement="top" width="600" trigger="hover">
              <div v-html="scope.row.definition_major_functions"></div>
              <div slot="reference">
                {{ scope.row.definition_major_functions | filterSplit }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="acupoint_selection_title" label="功效">
          <template slot-scope="scope">
            <el-popover placement="top" width="600" trigger="hover">
              <div v-html="scope.row.acupoint_selection_title"></div>
              <div slot="reference">
                {{ scope.row.acupoint_selection_title | filterSplit }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="acupoint_selection_content" label="功效介绍">
          <template slot-scope="scope">
            <el-popover placement="top" width="600" trigger="hover">
              <div v-html="scope.row.acupoint_selection_content"></div>
              <div slot="reference">
                {{ scope.row.acupoint_selection_content | filterSplit }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="acupoint_range" label="适用范围">
          <template slot-scope="scope">
            <el-popover placement="top" width="600" trigger="hover">
              <div v-html="scope.row.acupoint_range"></div>
              <div slot="reference">
                {{ scope.row.acupoint_range | filterSplit }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="acupoint_mark" label="备注">
          <template slot-scope="scope">
            <el-popover placement="top" width="600" trigger="hover">
              <div v-html="scope.row.acupoint_mark"></div>
              <div slot="reference">
                {{ scope.row.acupoint_mark | filterSplit }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              @click="editRow(scope.$index, scope.row, tableData)"
              type="primary"
              size="small"
              >编辑</el-button
            >
            <el-button
              @click="deleteRow(scope.$index, scope.row, tableData)"
              type="danger"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import debounce from "@/utils/debounce";
import { acupointList, delAcupoint } from "@/api/acupoint";
export default {
  name: "acupointList",
  data() {
    return {
      data: [],
      tableData: [],
      scrollHeight: 100,
      total: 100,
      currentPage: 1,
      pageSize: 10,
      keyword: "",
      previewList: [], // 预览图片
    };
  },
  watch: {
    // 关键字搜索
    keyword() {
      debounce(() => {
        this.$store.dispatch("fullscreenLoading", true);
        this.getData();
      }, 800);
    },
  },
  created() {
    this.$store.dispatch("fullscreenLoading", true);
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollHeight = document.body.clientHeight - 290;
    });
    this.getData();
  },
  methods: {
    // 获取穴位列表
    getData() {
      acupointList({
        type: 2,
        page: this.currentPage,
        limit: this.pageSize,
        keyword: this.keyword,
      }).then((res) => {
        this.total = res.data.total;
        this.data = res.data.list;
        this.tableData = res.data.list;
        this.$store.dispatch("fullscreenLoading", false);
      });
    },
    // 删除
    deleteRow(index, row, rows) {
      this.$confirm("是否要删除该项?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delAcupoint({
          id: row.id,
        }).then(() => {
          rows.splice(index, 1);
          this.$message.success("删除成功!");
          this.getData();
        });
      });
    },
    // 编辑
    editRow(index, row) {
      localStorage.setItem("acupointItem", JSON.stringify(row));
      this.$router.push({
        path: "/acupointAdd",
        query: {
          type: "modify",
          id: row.id,
          child: 2,
        },
      });
    },
    // 预览图片
    previewImg(url) {
      this.previewList = [url];
    },
    // 改变单页数量
    handleSizeChange(val) {
      this.pageSize = val;
      this.$store.dispatch("fullscreenLoading", true);
      this.getData();
    },
    // 切换页面
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$store.dispatch("fullscreenLoading", true);
      this.getData();
    },
  },
  filters: {
    /**
     * 内容过滤
     * @param {string} txt
     * @return {string}
     */
    filterSplit(txt) {
      let content = "";
      if (txt.split("").length > 5) {
        for (let i = 0; i < 5; i++) {
          content = content + txt.split("")[i];
        }
        content = content + "...";
      } else {
        content = txt;
      }
      return content;
    },
  },
};
</script>

<style scoped>
.header-flex {
  display: flex;
  align-items: center;
}

.header-flex h1 {
  margin: 0;
  padding: 0;
}

.input-flex {
  flex: 1;
  text-align: right;
}

.input {
  width: 200px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 15px;
}

.show-image {
  width: inherit;
}
</style>
